// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../index';

import { CostumerConsultantFragmentDoc } from './costumerConsultant.fragment.generated';
export const MeFragmentDoc = `
    fragment me on User {
  id
  firstName
  lastName
  email
  isConsultant
  createdAt
  customer {
    id
    billingAddress {
      phoneNumber {
        e164
        nationalNumber
        countryCode
      }
    }
    consultant {
      ...costumerConsultant
    }
    disabledThirdPartyCookies
    adminProfileUrl @include(if: $isConsultant)
    salesforceProfileUrl @include(if: $isConsultant)
  }
}
    `;